<template>
    <Block :withoutPadding="true">
        <MenuComponent>
            <MenuItem
                routeName="personalAccountProfile"
                data-cy="menu.my-account"
            >
                <span class="f2m-user" /> {{ $t('personal-account.personalAccountMenu.profile') }}
            </MenuItem>
            <MenuItem
                routeName="personalAccountInvoices"
                data-cy="menu.my-invoices"
            >
                <span class="f2m-invoice" /> {{ $t('personal-account.personalAccountMenu.invoices') }}
            </MenuItem>
            <MenuItem
                routeName="personalAccountCoupons"
                data-cy="menu.my-coupons"
            >
                <span class="f2m-rounded-percent" /> {{ $t('personal-account.personalAccountMenu.coupons') }}
            </MenuItem>
            <MenuItem
                routeName="personalAccountBookings"
                data-cy="menu.my-bookings"
            >
                <span class="f2m-calendar" /> {{ $t('personal-account.personalAccountMenu.bookings') }}
            </MenuItem>
            <MenuItem
                routeName="/cod/contracts"
                type="link"
                data-cy="menu.my-cods"
            >
                <span class="f2m-cod-car" /> {{ $t('personal-account.personalAccountMenu.myCods') }}
            </MenuItem>
            <MenuItem
                routeName="personalAccountSettings"
                data-cy="menu.settings"
            >
                <span class="f2m-setting" /> {{ $t('personal-account.personalAccountMenu.settings') }}
            </MenuItem>
        </MenuComponent>
    </Block>
</template>

<script>
import { Block } from '@free2move/vuejs-components';
import MenuComponent from '@/components/Menu.vue';
import MenuItem from '@/components/MenuItem.vue';

export default {
    components: {
        Block,
        MenuComponent,
        MenuItem
    },
};
</script>
